/*    
<summary>
  This functional component shows the tenant details.
  Developer:Aashish Singh, Created Date: 10-May-2024
</summary>
<returns>Returns JSX</returns>
*/

import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { FormattedMessage } from "react-intl";
import { useStore } from "../../contexts/StoreProvider";
import { ITenantList } from "../../models/response/ITenantResponse";
import FormLoader from "../../shared-components/FormLoader/FormLoader";
import "./tenant-detail.css";

interface IProps {
  selectedData: ITenantList;
}

const TenantDetails = (props: IProps) => {
  const { tenantStore } = useStore();
  const { GetTenantService, tenantDetails, tenant, tenantState } = tenantStore;

  /**
   * This function calls the "GetTenantService" store funtion that get group data from API
   */
  const callGetTenantById = () => {
    GetTenantService(props?.selectedData.Id, props.selectedData.UserId);
  };

  useEffect(() => {
    if (props?.selectedData.Id > 0) callGetTenantById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.selectedData.Id]);

  return (
    <React.Fragment>
        {tenantState.inProgress && <FormLoader loading={tenantState.inProgress} />}
        {
            tenant &&
            <div className="p-3">
                <div className="row pt-2">
                    <div className="col-12">
                        <label className="text-muted bold">
                        <FormattedMessage id={"tenant_email"} />:{" "}
                        </label>
                    </div>
                    <div className="col-12">
                        <p className="mw-100">
                            {tenantDetails.Email}
                        </p>
                    </div>
                </div>
                <div className="row pt-2">
                    <div className="col-6">
                        <label className="text-muted bold">
                        <FormattedMessage id={"user_limit"} />:{" "}
                        </label>
                        <p className="mw-100">
                            {tenantDetails.MaxUserAllow}
                        </p>
                    </div>
                    <div className="col-6">
                        <label className="text-muted bold">
                        <FormattedMessage id={"device_limit"} />:{" "}
                        </label>
                        <p className="mw-100">
                            {tenantDetails.MaxDeviceAllow}
                        </p>
                    </div>
                </div>
                <div className="row g-3 pt-3">
                    <div className="col-auto">
                        <label className={` ${tenantDetails.IsActive == true ? 'success' : 'danger' } tenant-alert`}>
                        {tenantDetails?.IsActive == true ? (
                            <svg clip-rule="evenodd" fill-rule="evenodd" height="512" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 2.54 2.54" width="512" xmlns="http://www.w3.org/2000/svg" id="fi_5610944"><g id="图层_x0020_1"><circle cx="1.27" cy="1.27" fill="#00ba00" r="1.27"></circle><path d="m.87344 1.88938-.46448-.49713c-.06359-.06806-.05994-.17574.00812-.23933.06806-.06359.17574-.05993.23933.00812l.35828.38346.56711-.52987c.0051-.00477.01043-.00914.01594-.01316l.26669-.24917c.06806-.06359.17575-.05993.23933.00813.06359.06805.05993.17574-.00812.23933l-.81454.76105-.00087-.00093-.28176.26326-.12503-.13382z" fill="#fff"></path></g></svg>
                        ) : (
                            <svg clip-rule="evenodd" fill-rule="evenodd" height="512" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 2.53988 2.53988" width="512" xmlns="http://www.w3.org/2000/svg" id="fi_5610967"><g id="图层_x0020_1"><circle fill="#ff1f1f" r="2.17" transform="matrix(.414 -.414 .414 .414 1.27 1.27)"></circle><g fill="#fff"><path d="m1.16935 1.61.44065-.44065.34759-.3476c.06586-.06586.06586-.1736 0-.23946-.06586-.06586-.1736-.06586-.23946 0l-.3476.34759-.44065.44065-.34759.3476c-.06586.06586-.06586.1736 0 .23946.06586.06586.1736.06586.23946 0z"></path><path d="m1.61 1.37053-.44065-.44065-.3476-.34759c-.06586-.06586-.1736-.06586-.23946 0-.06586.06586-.06586.1736 0 .23946l.34759.3476.44065.44065.3476.34759c.06586.06586.1736.06586.23946 0 .06586-.06586.06586-.1736 0-.23946z"></path></g></g></svg>
                        )}
                            <FormattedMessage id={"is_active"} />
                        </label>
                    </div>
                    <div className="col-auto">
                        <label className={` ${tenantDetails.IsDataPakcetsStoreInDB == true ? 'success' : 'danger' } tenant-alert`}>
                        {tenantDetails?.IsDataPakcetsStoreInDB == true ? (
                            <svg clip-rule="evenodd" fill-rule="evenodd" height="512" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 2.54 2.54" width="512" xmlns="http://www.w3.org/2000/svg" id="fi_5610944"><g id="图层_x0020_1"><circle cx="1.27" cy="1.27" fill="#00ba00" r="1.27"></circle><path d="m.87344 1.88938-.46448-.49713c-.06359-.06806-.05994-.17574.00812-.23933.06806-.06359.17574-.05993.23933.00812l.35828.38346.56711-.52987c.0051-.00477.01043-.00914.01594-.01316l.26669-.24917c.06806-.06359.17575-.05993.23933.00813.06359.06805.05993.17574-.00812.23933l-.81454.76105-.00087-.00093-.28176.26326-.12503-.13382z" fill="#fff"></path></g></svg>
                        ) : (
                            <svg clip-rule="evenodd" fill-rule="evenodd" height="512" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 2.53988 2.53988" width="512" xmlns="http://www.w3.org/2000/svg" id="fi_5610967"><g id="图层_x0020_1"><circle fill="#ff1f1f" r="2.17" transform="matrix(.414 -.414 .414 .414 1.27 1.27)"></circle><g fill="#fff"><path d="m1.16935 1.61.44065-.44065.34759-.3476c.06586-.06586.06586-.1736 0-.23946-.06586-.06586-.1736-.06586-.23946 0l-.3476.34759-.44065.44065-.34759.3476c-.06586.06586-.06586.1736 0 .23946.06586.06586.1736.06586.23946 0z"></path><path d="m1.61 1.37053-.44065-.44065-.3476-.34759c-.06586-.06586-.1736-.06586-.23946 0-.06586.06586-.06586.1736 0 .23946l.34759.3476.44065.44065.3476.34759c.06586.06586.1736.06586.23946 0 .06586-.06586.06586-.1736 0-.23946z"></path></g></g></svg>
                        )}
                        <FormattedMessage id={"store_in_DB"} />
                        </label>
                    </div>
                    <div className="col-auto">
                        <label className={` ${tenantDetails.SendThresholdAlert == true ? 'success' : 'danger' } tenant-alert`}>
                        {tenantDetails?.SendThresholdAlert == true ? (
                            <svg clip-rule="evenodd" fill-rule="evenodd" height="512" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 2.54 2.54" width="512" xmlns="http://www.w3.org/2000/svg" id="fi_5610944"><g id="图层_x0020_1"><circle cx="1.27" cy="1.27" fill="#00ba00" r="1.27"></circle><path d="m.87344 1.88938-.46448-.49713c-.06359-.06806-.05994-.17574.00812-.23933.06806-.06359.17574-.05993.23933.00812l.35828.38346.56711-.52987c.0051-.00477.01043-.00914.01594-.01316l.26669-.24917c.06806-.06359.17575-.05993.23933.00813.06359.06805.05993.17574-.00812.23933l-.81454.76105-.00087-.00093-.28176.26326-.12503-.13382z" fill="#fff"></path></g></svg>
                        ) : (
                            <svg clip-rule="evenodd" fill-rule="evenodd" height="512" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 2.53988 2.53988" width="512" xmlns="http://www.w3.org/2000/svg" id="fi_5610967"><g id="图层_x0020_1"><circle fill="#ff1f1f" r="2.17" transform="matrix(.414 -.414 .414 .414 1.27 1.27)"></circle><g fill="#fff"><path d="m1.16935 1.61.44065-.44065.34759-.3476c.06586-.06586.06586-.1736 0-.23946-.06586-.06586-.1736-.06586-.23946 0l-.3476.34759-.44065.44065-.34759.3476c-.06586.06586-.06586.1736 0 .23946.06586.06586.1736.06586.23946 0z"></path><path d="m1.61 1.37053-.44065-.44065-.3476-.34759c-.06586-.06586-.1736-.06586-.23946 0-.06586.06586-.06586.1736 0 .23946l.34759.3476.44065.44065.3476.34759c.06586.06586.1736.06586.23946 0 .06586-.06586.06586-.1736 0-.23946z"></path></g></g></svg>
                        )}
                        <FormattedMessage id={"send_alert"} />
                        </label>
                    </div>
                </div>
                
                <div className="card bg-light p-3">
                    <div className="row pt-2">
                        <div className="col-6">
                            <label className="text-muted bold">
                            <FormattedMessage id={"organization_name"} />:{" "}
                            </label>
                            <p className="mw-100">
                                {tenantDetails.OrganizationName}
                            </p>
                        </div>
                        <div className="col-6">
                            <label className="text-muted bold">
                            <FormattedMessage id={"organization_id"} />:{" "}
                            </label>
                            
                            <p className="mw-100">
                                {tenantDetails.OrganizationId}
                            </p>
                        </div>
                        <div className="col-6">
                            <label className="text-muted bold">
                            <FormattedMessage id={"vat_number"} />:{" "}
                            </label>
                            
                            <p className="mw-100">
                                {tenantDetails.VatNo}
                            </p>
                        </div>
                    </div> 
                    <hr/>
                    <div className="row pt-2">
                        <div className="col-2">
                            <label className="text-muted bold">
                            {/* <FormattedMessage id={"contact_person_name"} />:{" "} */}
                            <i className="fas fa-user tenant-contact-icon"></i>
                            </label>
                        </div>
                        <div className="col-10">
                            <h3 className="m-0">
                                {tenantDetails.ContactPersonName}
                            </h3>
                            <p className="mw-100 mb-0 text-muted">
                                {tenantDetails.ContactEmail}
                            </p>
                            <p className="mw-100 mb-0 text-muted">
                                {tenantDetails.ContactPhoneNumber}
                            </p>
                            <p className="mw-100">
                                {tenantDetails.ShippingAddress}
                            </p>
                        </div>
                    </div>
                    
                    
                </div>
                
            </div>
        }
    </React.Fragment>
  );
};

export default observer(TenantDetails);
